import React from 'react';
import { Container, Stack, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import BrudCrumbs from '../../components/BreadCrumbs';
import PartnerHierarchyPage from './PartnerHierarchyComponent';

export default function ViewPartnerHierarchy() {
  const location = useLocation();
  const partnerId = location.state?.partnerId;

  return (
    <Page title="Kpros by Kalolytic Solutions || Partner Hierarchy">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Partner Hierarchy" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Box mt={3}>
            {partnerId ? (
              <PartnerHierarchyPage partnerId={partnerId} />
            ) : (
              <Box p={3}>No Partner ID provided.</Box>
            )}
          </Box>
        </Box>
      </Container>
    </Page>
  );
}
